<script>
    import { onMount, createEventDispatcher } from 'svelte';
    // import { Link, navigate } from 'svelte-routing'
    import { Link, navigateTo } from 'yrv';


    import axios from 'axios'
    import wait from '../../libs/wait';

    import FadeinFX from '../../components/FX/FadeinFx.svelte';
    import AdminLayout from '../../layouts/AdminLayout.svelte';
    import Sidepanel from '../../components/Sidepanel/Sidepanel.svelte'
    import SidepanelContent from './QuerySideContent.svelte'

    // import userStore from '../../stores/user'
    // import storage from '../../libs/storage'

    export let id

    const dispatch = createEventDispatcher ();
    
    let screenReady = false,
        operators   = [],
        sideModel   = {},
        sector      = null,
        model       = null;

    const onQuery = (event) => {
        const { detail } = event;
        // console.log ('onQuery', detail)
        if (detail.type === 'op-activity') {
            window.open (`/api/activity/listByOperator?operator=${detail.operator}&month=${detail.month}&output=html`)
        }

        else if (detail.type === 'month-overtime') {
            window.open (`/api/query/monthOvertime?month=${detail.month}&category=${id}&output=html`)
        }
    }

    const fetchModel = (sectorId) => {
        dispatch ('app-event', { id: 'background', value: true });
        Promise.all ([
            axios.request ({
                method: 'get',
                url: '/api/categories/get/' + sectorId
            }),
            axios.request ({
                method: 'get',
                url: '/api/users/operators/' + sectorId
            })
            // axios.request ({
            //     method: 'get',
            //     url: '/api/categories/olist'
            // })
        ]).then (results => {
            sector = results[0].data
            operators = results[1].data
            sideModel = {
                sector: sector,
                operators: operators
            }
            // sector = result.data;
            dispatch ('app-event', { id: 'background', value: false });
        }).catch (e => {
            dispatch ('app-event', { id: 'app-error', error: e });
        })
    }

    $: {
        fetchModel (id)
    }
</script>


<Sidepanel>
    <SidepanelContent data={sideModel} on:query={onQuery} />
</Sidepanel>
<AdminLayout classes="sidepanel">
    <div class="page-pad avoid-selection">
        
    </div>
</AdminLayout>


<style>
    
</style>